import { ArrowLeft, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export function CareersSalesSpecialist2() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <div className="pt-28 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate("/careers")}
            className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition font-medium mb-8"
          >
            <ArrowLeft size={20} />
            Back to careers
          </button>
        </div>
      </div>

      {/* Job Header */}
      <section className="px-6 lg:px-8 pb-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-4">Sales Specialist</h1>
          <p className="text-xl mb-8">📍 Chennai, India</p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="px-6 lg:px-8 py-24 border-t border-gray-800">
        <div className="max-w-4xl mx-auto space-y-16">
          {/* About the Role */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About the company</h2>
            <p>
              ExpenseHut is a digital platform designed to enhance businesses
              and individuals by boosting financial and everyday productivity.
              We are an Austin-based startup, and we offer innovative and
              advanced solutions that address real-world challenges across
              industries like retail, restaurants, staffing, and content.
            </p>
            <p>
              Business, by ExpenseHut is an all-in-one enterprise business
              software suite that includes POS with omnichannel payments,
              embedded payroll, bookkeeping software, and rewards. Our platform
              features tools tailored to businesses of all sizes, with the aim
              of helping users gain financial clarity and achieve lasting
              success.
            </p>
            <p>
              Join us in making smarter decisions today for a more prosperous
              tomorrow!
            </p>
          </div>

          {/* Responsibilities */}
          <div>
            <h2 className="text-3xl font-bold   mb-6">Responsibilities</h2>
            <ul className="space-y-4">
              <li>
                <strong>Client Acquisition & Retention:</strong>
                Identify and target potential clients, build relationships, and
                convert leads into customers. Maintain and grow relationships
                with existing clients to ensure satisfaction and retention.
              </li>
              <li>
                <strong>Sales Strategy & Execution:</strong>
                Develop and implement sales strategies to achieve revenue
                targets. Create and deliver compelling sales presentations to
                key stakeholders.
              </li>

              <li>
                <strong>Market Research:</strong>
                Conduct market research to identify trends, customer needs, and
                competitive landscape. Use insights to inform sales strategies
                and product development.
              </li>
              <li>
                <strong>Product Knowledge:</strong>
                Maintain a deep understanding of our products and services.
                Communicate product benefits and features effectively to
                potential clients.
              </li>
              <li>
                <strong>Sales Reporting:</strong>
                Track and report on sales performance metrics. Provide regular
                updates to management on sales activities, pipeline status, and
                revenue forecasts.
              </li>
              <li>
                <strong>Collaboration:</strong>
                Work closely with marketing, product, and customer support teams
                to ensure a seamless customer experience. Provide feedback to
                improve product offerings and sales processes.
              </li>
              <li>
                <strong>Customer Feedback:</strong>
                Gather and analyze customer feedback to identify areas for
                improvement. Use feedback to enhance customer satisfaction and
                drive product innovation.
              </li>
            </ul>
          </div>

          {/* Requirements */}
          <div>
            <h2 className="text-3xl font-bold   mb-6">Requirements</h2>
            <ul className="space-y-4">
              <li>
                Minimum 5 years of experience in sales, preferably in the
                technology or software industry.
              </li>
              <li>
                Proven track record of meeting or exceeding sales targets and
                driving revenue growth.
              </li>
              <li>
                Excellent communication, negotiation, and presentation skills.
              </li>
              <li>
                Strong understanding of market research techniques and data
                analysis.
              </li>
              <li>
                Ability to build and maintain strong client relationships and
                work collaboratively with cross-functional teams.
              </li>
            </ul>
          </div>

          {/* How to Apply */}
          <div className="border border-gray-700 rounded-xl p-8">
            <h2 className="text-2xl font-bold mb-4">How to Apply</h2>

            <p>
              Please email <strong>jobs@expensehut.com</strong> with your resume
              attached. Please make sure to answer the following questions to
              help us understand your experience better.
            </p>
          </div>
        </div>
        <div className="p-6 text-gray-600 mt-10">
          ExpenseHut is an Equal Employment Opportunity and, in the U.S., an
          Affirmative Action employer. All qualified applicants will receive
          consideration for employment without regard to unlawful consideration
          of race, color, religion, creed, national or ethnic origin, ancestry,
          place of birth, citizenship, sex, pregnancy / childbirth or related
          medical conditions, sexual orientation, gender identity or expression,
          marital or domestic partnership status, age, veteran or military
          status, physical or mental disability, medical condition, genetic
          information, political / organizational affiliation, status as a
          victim or family member of a victim of crime or abuse, or any other
          status protected by applicable law.
        </div>
      </section>
    </div>
  );
}
